import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Container,
  Grid,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  Backdrop,
  TextareaAutosize,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
const DiagnosisRegistration = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const diagnosisId = location.state?.did || 0;
  const token = localStorage.getItem("Thyra_Token");
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  const defaultValues = {
    id: 0,
    practiceId: 0,
    code: "",
    name: "",
    shortDescription: "",
    description: "",
    patientId: 0,
  };

  const fields = [
    "id",
    "practiceId",
    "code",
    "name",
    "shortDescription",
    "description",
    "patientId",
  ];

  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues,
  });
  const [submitting, setSubmitting] = useState(false);
  const [isDialogOpenResp, setDialogOpenResp] = useState(false);

  useEffect(() => {
    if (diagnosisId > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Diagnosis/getDiagnosisById?id=${diagnosisId}`,
          { headers }
        )
        .then((response) => {
          fields.forEach((field) => setValue(field, response[field]));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [diagnosisId, setValue]);

  const onSubmit = (data) => {
    setSubmitting(true);
    if (!data.code) {
      alert("Please enter a valid code.");
      setSubmitting(false);
      return;
    }
    if (!data.name) {
      alert("Please enter a valid name.");
      setSubmitting(false);
      return;
    }
    axios
      .post(`${process.env.REACT_APP_API_URL}/Diagnosis/addDiagnosis`, data, {
        headers,
      })
      .then((response) => {
        if (response.id) {
          setSubmitting(false);
          setDialogOpenResp(true);
          setTimeout(() => {
            navigate("/Diagnosis");
            setDialogOpenResp(false);
          }, 1000);
        } else {
          setSubmitting(false);
        }
      })
      .catch((error) => {
        console.error("Error submitting data:", error);
        setSubmitting(false);
      });
  };

  const handleCancel = () => {
    navigate("/Diagnosis");
  };

  return (
    <Container sx={{ pt: 10, pb: 4, maxWidth: "lg" }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: "#2B7B7E" }}>
          Diagnosis Registration
        </Typography>
      </Box>
      <Dialog
        open={isDialogOpenResp}
        onClose={() => setDialogOpenResp(false)}
        BackdropComponent={Backdrop}
        BackdropProps={{ invisible: true }}
        PaperProps={{
          style: {
            marginRight: "5px",
            float: "right",
            marginTop: "5px",
            color: "red",
            cursor: "pointer",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "8px",
            width: "500px",
            p: 2,
          }}
        >
          <CheckCircleIcon sx={{ fontSize: "100px", color: "green" }} />
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "16px",
              fontWeight: "normal",
              color: "#444444",
              mt: 2,
            }}
          >
            Diagnosis added successfully
          </Typography>
          <DialogContent>
            <DialogContentText></DialogContentText>
          </DialogContent>
        </Box>
      </Dialog>

      {/* Form */}
      <Box
        sx={{
          bgcolor: "#FFFFFF",
          borderRadius: "12px",
          boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
          p: 4,
        }}
      >
        <Grid className="row">
          {/* Name */}
          <Grid className="col-md-4">
            <Typography component="label" sx={{ color: "black", mb: 1 }}>
              Name
            </Typography>
            <TextField
              {...register("name")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter Diagnosis Name"
            />
          </Grid>
          {/* Code */}
          <Grid className="col-md-4">
            <Typography component="label" sx={{ color: "black", mb: 1 }}>
              Code
            </Typography>
            <TextField
              {...register("code")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Code"
            />
          </Grid>
        </Grid>

        {/* Description */}
        <Grid className="col-md-4">
          <Typography component="label" sx={{ color: "black", mb: 1 }}>
            Description
          </Typography>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <TextareaAutosize
                aria-label="minimum height"
                minRows={3}
                placeholder="Enter Description"
                style={{
                  width: "1000px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  padding: "8px",
                  resize: "vertical",
                }}
                {...field}
              />
            )}
          />
        </Grid>

        <Grid container spacing={2}>
          {/* Short Description */}
          <Grid item xs={12} md={12}>
            <Typography component="label" sx={{ color: "black", mb: 1 }}>
              Short Description
            </Typography>
            <Controller
              name="shortDescription"
              control={control}
              render={({ field }) => (
                <TextareaAutosize
                  aria-label="minimum height"
                  minRows={3}
                  placeholder="Enter Short Description"
                  style={{
                    width: "1000px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                    padding: "8px",
                    resize: "vertical",
                  }}
                  {...field}
                />
              )}
            />
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            mt: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleCancel}
            sx={{
              width: "100px",
              height: "35px",
              backgroundColor: "#2B7B7E",
              color: "white",
              borderRadius: "80px",
              fontSize: "14px",
              "&:hover": { backgroundColor: "#1a1a1a" },
            }}
          >
            <CancelOutlinedIcon
              fontSize="medium"
              style={{ color: "red", paddingRight: "5px" }}
            />
            Cancel
          </Button>
          <Button
            onClick={handleSubmit(onSubmit)}
            disabled={submitting}
            sx={{
              width: "100px",
              height: "35px",
              backgroundColor: "#2B7B7E",
              color: "white",
              borderRadius: "80px",
              fontSize: "14px",
              "&:hover": { backgroundColor: "#1a1a1a" },
            }}
          >
            <SaveOutlinedIcon sx={{ color: "white", mr: 1 }} />
            Save
          </Button>
        </Grid>
      </Box>
    </Container>
  );
};
export default DiagnosisRegistration;
